'use client';

import type { getDictionary } from '@up2promo-setup-frontend/dictionary';
import { createContext, useContext } from 'react';

import type { Locale } from '../../../i18n-config';

type Dictionary = Awaited<ReturnType<typeof getDictionary>>;

const DictionaryContext = createContext<Dictionary | null>(null);
const LocaleContext = createContext<Locale | null>(null);

export function DictionaryProvider({
  dictionary,
  lang,
  children,
}: {
  dictionary: Dictionary;
  lang: Locale;
  children: React.ReactNode;
}) {
  return (
    <LocaleContext.Provider value={lang}>
      <DictionaryContext.Provider value={dictionary}>
        {children}
      </DictionaryContext.Provider>
    </LocaleContext.Provider>
  );
}

export function useDictionary() {
  const dictionary = useContext(DictionaryContext);
  if (dictionary === null) {
    throw new Error(
      'useDictionary hook must be used within DictionaryProvider',
    );
  }

  return dictionary;
}

export function useLocale() {
  const lang = useContext(LocaleContext);
  if (lang === null) {
    throw new Error('useLocale hook must be used within LocaleProvider');
  }

  return lang;
}
